module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/yaji_u-01699c2ea2cea54c04217c59e2fe5a79.png";